import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import "@/style/common.scss";
import apiList from "@/api/apiList.js";
import actions from "@/store/shardActions";
import preventReClick from "@/directive/noDbClick";
import HanshowUI from "hanshow-ui";
import "./style/common.scss";
import createNotice from "@/common/noticeTip";
import "@/style/vue3-rest.scss";
import './style/hanshow-plus.css'

Vue.config.productionTip = false;
Vue.prototype.$httpList = apiList;
Vue.prototype.$actions = actions;
Vue.prototype.$createNotice = createNotice;
Vue.prototype.$isProduction = process.env.NODE_ENV === "production";
Vue.use(preventReClick);
Vue.use(HanshowUI,{zIndex:20000});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
